module.exports = __webpack_public_path__ + "static/media/work (6).8195e55e.jpg";